/// <reference path="../../apps/typings/customTds.d.ts"/>

export class PiwikTrackingService {

	public getLinkerParamFromDatalayer(): string {
		if (typeof window === 'undefined' || !window.dataLayer) {
			return '';
		}

		const dataLayer = window.dataLayer as Array<Record<string, any>>;

		for (const entry of dataLayer) {
			if (entry && entry.linkerParam) {
				return entry.linkerParam;
			}
		}

		return '';
	}
}